export default __webpack_public_path__ + "static/media/36.1144aa3f.jpg";